import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IGruntItem, IGruntState} from "./types";
import {fetchAllGruntReserve, fetchGruntArenas} from "./asyncAction";
import {IArena} from "../../rent/types";

const initialState: IGruntState = {
  grunt_id: null,
  gruntsAvailable: false,
  isLoading: false,
  items: [],
  gruntArenas: []
}

const GetGrunt = createSlice({
  name: "getGrunt",
  initialState,
  reducers: {
    setGruntId(state, action: PayloadAction<number>) {
      state.grunt_id = action.payload
    },
    setGruntAvailable(state, action: PayloadAction<boolean>) {
      state.gruntsAvailable = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllGruntReserve.pending,
      (state) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      fetchAllGruntReserve.fulfilled,
      (state, action: PayloadAction<IGruntItem[]>) => {
        state.items = action.payload
        state.isLoading = false;
      }
    );
    builder.addCase(
      fetchGruntArenas.fulfilled,
      (state, action: PayloadAction<IArena[]>) => {
        state.gruntArenas = action.payload
      }
    )
  }
})

export default GetGrunt.reducer;

export const {setGruntId, setGruntAvailable} = GetGrunt.actions;
